import $ from 'jquery'

import store from 'store2'

import prepare from '../../../lib/prepare'

import background from './background/background.js'
import timeline from './timeline/timeline.js'
import container from './container/container.js'
import shortcuts from './shortcuts/shortcuts.js'
import filter from './filter/filter.js'

export default function(o){

  shortcuts(o)

  var backgroundDiv = background()
  var containerDiv = container(o)
  var timelineDiv = timeline(o)
  var filterDiv = filter(o)

  if(Config.resolutions[480]){
    var format = 480
  } else {
    var format = MaxResolution
  }

  var updateMarkers = function(){
    timelineDiv.set()
  }

  var error = function(e){
    console.error('error',e)
    containerDiv.empty()
    o.video = null
    o.roll = null
    o.loading = false
    o.controls.set(false)
  }

  var success = function(roll,video,brightness){

    if(o.video){
      o.video.pause()
      o.video.src = ''
      o.video.load = ''
      o.video.remove()
    }

    o.video = video
    o.roll = roll
    o.loading = false

    $(video).attr({
      width: 400,
      height: 300,
    })

    if(brightness){
      $(video).css({
        filter: "brightness(" + brightness + ")",
      })
    }

    containerDiv.empty()

    containerDiv.append(video)

    timelineDiv.set(roll)

    o.controls.set(roll)

    if(o.playing){
      video.play()
    }

  }

  var currentFilter = null
  var setFilter = function(filter){
    if(!_.isEqual(currentFilter,filter)){
      currentFilter = filter
      //console.log('setFilter', filter, currentRoll)
      if(filter){
        if(o.playing){
          o.playing = false
          o.video.pause()
        }
        if(o.video){
          o.video.currentTime = o.loopStart
        }
        filterDiv.set(currentRoll.roll, o.loopStart, currentFilter)
        filterDiv.show()
      } else {
        filterDiv.hide()
      }
    }
  }

  var currentRoll = null
  var update = function(){
    load(currentRoll,o.video.currentTime)
  }

  var load = function(roll,start,brightness){

    currentRoll = roll
    o.loopStart = start

    if(!o.loading){

      o.loading = true

      var start = start || 0

      var file = `omb_${roll.roll}_${format}.mp4`

      prepare(file,format,start,function(e,video){
        if(e){
          error(e)
          o.loading = false
        } else {
          o.loopStart = start
          var r = roll.roll
          success(r,video,brightness)
        }
      })

    }

  }

  var loadSequence = function(sequence){

    if(!o.loading){

      var videoServer = o.store('videoServer')

      var file = sequence.files[format]

      var video =
        $('<video>').attr({
          src: `${videoServer}stream/sequence/${format}/${file}`,
          controls: false,
          muted: true,
          playsinline: true,
          width: 400,
          height: 300,
          preload: 'none',
        })

      video[0].load()

      video[0].addEventListener('ended',function(){
        this.currentTime = 0
        this.play()
      })

      var check = function(){
        requestAnimationFrame(function(){

          if(video[0].readyState > 3){

            o.roll = null
            o.sequence = sequence

            if(o.video){
              o.video.pause()
              o.video.src = ''
              o.video.load = ''
              o.video.remove()
            }

            o.video = video[0]

            o.loading = false

            containerDiv.empty()

            containerDiv.append(video)

            timelineDiv.setSequence(sequence)

            o.controls.setSequence(sequence)

            if(o.playing){
              o.video.play()
            }

          } else {
            check()
          }

        })
      }

      check()

    }

  }

  var div =
    $('<div>')
    .css({
      position: 'fixed',
      top: '34px',
      left: 0,
      width: '400px',
      height: '368px',
    })
    .append([
      backgroundDiv,
      containerDiv,
      timelineDiv,
      filterDiv,
    ])

  div.load = load
  div.update = update
  div.loadSequence = loadSequence
  div.updateMarkers = updateMarkers
  div.setFilter = setFilter

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/player/player.js